import React from "react";
import SquadflixHomeOptions from "./squadflix-home-options/squadflix-home-options";
import auth from "../../../utils/authentication";
import TmdbCollectionSelector from "../movies/tmdbCollectionSelector/tmdbCollectionSelector";
import useUserPreferences from "../../user-app-config/hooks/use-user-preferences";
import TmdbCredits from "../shared/tmdb-credits/tmdb-credits";
import UseSquadflixItemsRows from "./hooks/useSquadflixItemsRows";
import SquadflixTrendingHeader from "./squadflix-trending-header/squadflix-trending-header";
import ButtonV2 from "../../shared/button-v2/button-v2";
import {isMobileDevice} from "../../../utils/utils";

const SquadflixHome = () => {
    const {userPreferences, updatePreference} = useUserPreferences();
    const itemsRowsHook = UseSquadflixItemsRows({
        preferences: userPreferences?.squadflixHomePreferences,
        collections: userPreferences?.squadflixHomeCollections
    });
    const preferences = userPreferences?.squadflixHomePreferences;

    const handleShowAddCollection = (collection) => {
        if (userPreferences.squadflixHomeCollections?.includes(collection.id)) {
            return;
        }
        updatePreference("squadflixHomeCollections", [...(userPreferences.squadflixHomeCollections || []), collection.id]);
    }

    const handleHideCollection = (collectionId) => {
        const newCollections = (userPreferences.squadflixHomeCollections || []).filter((id) => id !== collectionId);
        updatePreference("squadflixHomeCollections", newCollections);
    }


    if (!auth.currentUser) {
        return null;
    }

    if (!preferences) {
        return null;
    }

    return (
        <div style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "22px",
            zIndex: 0,
            marginBottom: "30px",
        }}>
            <SquadflixTrendingHeader headerType={userPreferences.squadflixHomePreferences.headerType}/>
            <SquadflixHomeOptions/>
            {itemsRowsHook.itemsRows.map((itemRow) => {
                return <React.Fragment key={itemRow.id}>
                    {itemsRowsHook.getComponent(itemRow.id, handleHideCollection)}
                </React.Fragment>;
            })}
            {!itemsRowsHook.ableReorder && <div style={{order: itemsRowsHook.itemsRows.length + 100}}
                                                className="d-flex justify-content-center mt-3 gap-4 flex-wrap">
                <TmdbCollectionSelector
                    disabledCollections={userPreferences.squadflixHomeCollections || []}
                    actionText="Mostrar"
                    onSelected={handleShowAddCollection}
                    customBtn={
                        <>Mostrar colección <i className="fa-solid fa-plus ps-3"></i></>
                    }/>
                <ButtonV2 onClick={() => itemsRowsHook.setAbleReorder(true)}>
                    Reordenar <i className="fa-solid fa-sort ps-3"></i>
                </ButtonV2>
            </div>}
            {itemsRowsHook.ableReorder && <div
                style={{
                    order: itemsRowsHook.itemsRows.length + 100,
                    position: "fixed",
                    bottom: isMobileDevice() ? 80 : 40,
                    left: 0,
                    right: 0,
                    zIndex: 4,
                }}
                className="d-flex justify-content-center mt-3 gap-4 flex-wrap">
                <ButtonV2 variant="primary" onClick={() => itemsRowsHook.setAbleReorder(false)}>
                    Confirmar <i className="fa-solid fa-check ps-3"></i>
                </ButtonV2>
            </div>}
            <TmdbCredits style={{order: itemsRowsHook.itemsRows.length + 101}}/>
        </div>
    );
}

export default SquadflixHome;
